var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "Circle",

    getDefaultProps () {
        return {"data-svgreactloader":"[[null,\"rdf\",\"http://www.w3.org/1999/02/22-rdf-syntax-ns#\"],[\"http://www.w3.org/2000/svg\",\"cc\",\"http://creativecommons.org/ns#\"],[\"http://www.w3.org/2000/svg\",\"dc\",\"http://purl.org/dc/elements/1.1/\"]]","xmlns":"http://www.w3.org/2000/svg","height":"64","width":"64","version":"1.1","viewBox":"0 0 63.999999 63.999999"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <g transform="translate(0 -988.36)">
    <circle data-svgreactloader="[[null,&quot;style&quot;,&quot;color-rendering:auto;color:#000000;isolation:auto;mix-blend-mode:normal;shape-rendering:auto;solid-color:#000000;image-rendering:auto&quot;]]" cx="32" cy="1020.4" r="32"/>
  </g>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/app/assets/icons/circle.svg